import React from 'react'

import styles from './detail.module.scss'

const SectionHeader = ({ icon, iconClassName, title }) => {
  return (
    <div className={styles.sectionHeader}>
      <span className={`${styles.sectionIcon} ${iconClassName}`}>{icon}</span>
      <span className={styles.sectionTitle}>{title}</span>
    </div>
  )
}

export default SectionHeader
